/*
 * Created on Wed Oct 11 2023 4:56:55 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import moment from 'moment-timezone';

export const formatTime12Hour = (time24) => {
  if (!time24) return '--:--';
  const [hour, min] = time24.split(':').map(Number);
  const period = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 || 12;
  return `${hour12}:${min.toString().padStart(2, '0')} ${period}`;
};

export const formatSelectedTimeRange = (selectedTime, formatTime12Hour) => {
  if (!selectedTime?.start || !selectedTime?.end) {
    return 'No time selected';
  }
  return `${formatTime12Hour(selectedTime.start)} - ${formatTime12Hour(selectedTime.end)}`;
};

export const formatDate = (date) => moment(date).format('MMM DD, YYYY');

export const getActualEndTime = (selectedTime) => selectedTime?.end;

export const stripHtml = (html = '') => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};